'use client';

import { useEffect } from 'react';
import Footer from '@/app/homepage/components/Footer';
import HeroSection from './components/HeroSection';
import InquiryFormSection from './components/InquiryFormSection';
import DistributorFormSection from './components/DistributorFormSection';
import SupportContactSection from './components/SupportContactSection';
import OfficeLocationSection from './components/OfficeLocationSection';

export default function ContactPage() {
  useEffect(() => {
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    });

    const revealElements = document.querySelectorAll('.reveal');
    revealElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="min-h-screen bg-white">
      <HeroSection />
      <InquiryFormSection />
      <DistributorFormSection />
      <SupportContactSection />
      <OfficeLocationSection />
      <Footer />
    </main>
  );
}